/* eslint-disable no-useless-catch */
import { ENV } from "../utils";

export class InstitutionalDocument {
  baseApi = ENV.BASE_API;

  async getInstitutionalDocuments(accessToken, year) {
    try {
      let url = `${this.baseApi}/${ENV.API_ROUTES.INSTITUTIONAL_DOCUMENT}`;
      if (year) url += `?year=${year}`;
      const params = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      };
      const response = await fetch(url, params);
      const result = await response.json();
      if (response.status !== 200) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }

  async getInstitutionalDocument(accessToken, documentId) {
    try {
      const url = `${this.baseApi}/${ENV.API_ROUTES.INSTITUTIONAL_DOCUMENT}/${documentId}`;
      const params = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      };
      const response = await fetch(url, params);
      const result = await response.json();
      if (response.status !== 200) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }

  async createInstitutionalDocument(accessToken, data) {
    try {
      const formData = new FormData();
      Object.keys(data).forEach((key) => {
        if (data[key] !== undefined && data[key] !== null) {
          formData.append(key, data[key]);
        }
      });
      const url = `${this.baseApi}/${ENV.API_ROUTES.INSTITUTIONAL_DOCUMENT}`;
      const params = {
        method: "POST",
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
        body: formData,
      };
      const response = await fetch(url, params);
      const result = await response.json();
      if (response.status !== 201) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }

  async updateInstitutionalDocument(accessToken, documentId, data) {
    try {
      const formData = new FormData();
      Object.keys(data).forEach((key) => {
        if (data[key] !== undefined && data[key] !== null) {
          formData.append(key, data[key]);
        }
      });
      const url = `${this.baseApi}/${ENV.API_ROUTES.INSTITUTIONAL_DOCUMENT}/${documentId}`;
      const params = {
        method: "PATCH",
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
        body: formData,
      };
      const response = await fetch(url, params);
      const result = await response.json();
      if (response.status !== 200) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }

  async deleteInstitutionalDocument(accessToken, documentId) {
    try {
      const url = `${this.baseApi}/${ENV.API_ROUTES.INSTITUTIONAL_DOCUMENT}/${documentId}`;
      const params = {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      };
      const response = await fetch(url, params);
      const result = await response.json();
      if (response.status !== 200) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }
}
